import React from 'react'
import { GRID_LAYOUT } from '../../actions/ui'
import styled, { css } from 'styled-components'
import { UIStyles, surfaces } from '../../theme'
import capitalize from 'lodash/capitalize'
import { StyledTooltip } from '../UIComponents/StyledTooltip'

// A round button as tall as the filter pills, with their mint contour; it fills mint under the pointer.
// Beside a filter bar it becomes a tile as tall as the bar, with the bar's own card look.
const StyledIcon = styled.i`
  width: 34px;
  height: 34px;
  padding: 5px;
  border: 1px solid ${UIStyles.mintColor};
  border-radius: 50%;
  cursor: pointer;
  font-size: 15px;
  color: ${UIStyles.mintColor};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
  &:hover {
    background-color: ${UIStyles.mintColor};
    color: ${UIStyles.deepblueColor3};
  }
  ${({ besideBar }) =>
    besideBar &&
    css`
      width: 60px;
      height: 60px;
      font-size: 20px;
      background-color: ${UIStyles.deepblueColor3};
      border-color: ${UIStyles.mintBorder};
      border-radius: 12px;
      box-shadow: ${surfaces.floatingPanelShadow};
      &:hover {
        border-color: ${UIStyles.mintColor};
      }
    `}
`

export default function SwitchLayoutIcon({ chartsLayout, setChartsLayoutList, setChartsLayoutGrid, t, besideBar = false }) {
  const isGridLayout = chartsLayout === GRID_LAYOUT
  const handleLayoutChange = isGridLayout ? setChartsLayoutList : setChartsLayoutGrid
  const tooltipTitle = `${t('view')} ${isGridLayout ? t('list') : t('grid')}`

  return (
    <StyledTooltip title={capitalize(tooltipTitle)} placement="left">
      <StyledIcon className={`fas fa-${isGridLayout ? 'bars' : 'th-large'}`} onClick={handleLayoutChange} besideBar={besideBar} />
    </StyledTooltip>
  )
}
